import { TeamsPage as Teams } from '../pages';
import { WithRouteData } from '../render-routes';

export const TeamsPage = () => {
  return <Teams />;
};

export default WithRouteData(TeamsPage);
